/* Gravur-MAX Kategorieseite: Filter und Sortierung im Browser (Webstra 10/2026).
   Werte kommen aus data-f-* der Produktkacheln. Innerhalb einer Gruppe ODER, zwischen Gruppen UND. */
(function(){
  var root=document.querySelector('[data-wb-col]');if(!root)return;
  var grid=root.querySelector('[data-wb-grid]'),tool=root.querySelector('[data-wb-tool]');if(!grid||!tool)return;
  var items=[].slice.call(grid.querySelectorAll('[data-wb-item]'));if(!items.length)return;
  var box=tool.querySelector('[data-wb-filters]'),cnt=tool.querySelector('[data-wb-count]'),sort=tool.querySelector('[data-wb-sort]');
  var act=root.querySelector('[data-wb-active]'),none=root.querySelector('[data-wb-none]');
  var G=[{k:'art',l:'Produktart'},{k:'set',l:'Set'},{k:'name',l:'Wunschname'},{k:'thema',l:'Thema'}];
  var ORDER={set:['1 Glas','2er-Set','Mit Holzbox'],name:['Mit Wunschname','Ohne Wunschname']};
  function vals(el,k){var v=el.getAttribute('data-f-'+k)||'';return v.split('|').map(function(s){return s.trim();}).filter(Boolean);}
  var sel={},groups=[];
  G.forEach(function(g){
    var all={};items.forEach(function(el){vals(el,g.k).forEach(function(v){all[v]=(all[v]||0)+1;});});
    var keys=Object.keys(all);if(keys.length<2)return;
    var o=ORDER[g.k];keys.sort(o?function(a,b){return o.indexOf(a)-o.indexOf(b);}:function(a,b){return all[b]-all[a]||a.localeCompare(b,'de');});
    g.vals=keys;sel[g.k]=[];groups.push(g);
  });
  /* Auswahl aus der Adresse übernehmen (z. B. ?thema=Liebe) */
  try{var q=new URLSearchParams(location.search);groups.forEach(function(g){var v=q.get(g.k);if(v)sel[g.k]=v.split(',').filter(function(x){return g.vals.indexOf(x)>-1;});});}catch(e){}

  var uid=0;
  groups.forEach(function(g){
    var d=document.createElement('details');d.className='wb-dd';d.setAttribute('data-g',g.k);
    var id='wbdd'+(++uid);
    d.innerHTML='<summary aria-controls="'+id+'">'+g.l+'</summary><div class="wb-dd__panel" id="'+id+'" role="group" aria-label="'+g.l+'"><div class="wb-dd__head"><span>'+g.l+'</span><button type="button" class="wb-dd__close">Fertig</button></div></div>';
    var p=d.querySelector('.wb-dd__panel');
    g.vals.forEach(function(v){
      var lab=document.createElement('label');lab.className='wb-dd__opt';
      var inp=document.createElement('input');inp.type='checkbox';inp.value=v;inp.checked=sel[g.k].indexOf(v)>-1;
      var t=document.createElement('span');t.textContent=v;var n=document.createElement('small');
      lab.appendChild(inp);lab.appendChild(t);lab.appendChild(n);p.appendChild(lab);
      inp.addEventListener('change',function(){var a=sel[g.k],i=a.indexOf(v);if(inp.checked&&i<0)a.push(v);if(!inp.checked&&i>-1)a.splice(i,1);apply();});
    });
    d.querySelector('.wb-dd__close').addEventListener('click',function(){d.open=false;d.querySelector('summary').focus();});
    d.addEventListener('toggle',function(){if(d.open)[].forEach.call(box.querySelectorAll('.wb-dd[open]'),function(o){if(o!==d)o.open=false;});});
    box.appendChild(d);
  });
  document.addEventListener('click',function(e){[].forEach.call(box.querySelectorAll('.wb-dd[open]'),function(o){if(!o.contains(e.target))o.open=false;});});
  document.addEventListener('keydown',function(e){if(e.key!=='Escape')return;var o=box.querySelector('.wb-dd[open]');if(o){o.open=false;o.querySelector('summary').focus();}});

  function match(el,skip){
    return groups.every(function(g){if(g.k===skip||!sel[g.k].length)return true;var v=vals(el,g.k);return sel[g.k].some(function(s){return v.indexOf(s)>-1;});});
  }
  function apply(){
    var shown=0;
    items.forEach(function(el){var ok=match(el);el.hidden=!ok;if(ok)shown++;});
    cnt.textContent=shown+(shown===1?' Produkt':' Produkte');
    none.hidden=shown>0;
    /* Zähler je Option (unter Berücksichtigung der anderen Gruppen) */
    groups.forEach(function(g){
      var d=box.querySelector('[data-g="'+g.k+'"]'),n=sel[g.k].length,s=d.querySelector('summary');
      d.classList.toggle('is-on',n>0);
      s.innerHTML=g.l+(n?' <span class="wb-dd__n" aria-label="'+n+' ausgewählt">'+n+'</span>':'');
      [].forEach.call(d.querySelectorAll('.wb-dd__opt'),function(lab){
        var v=lab.querySelector('input').value,c=0;
        items.forEach(function(el){if(match(el,g.k)&&vals(el,g.k).indexOf(v)>-1)c++;});
        lab.querySelector('small').textContent=c;lab.classList.toggle('is-zero',c===0&&!lab.querySelector('input').checked);
      });
    });
    /* aktive Filter als entfernbare Pillen */
    act.innerHTML='';var any=false;
    groups.forEach(function(g){sel[g.k].forEach(function(v){
      any=true;var b=document.createElement('button');b.type='button';b.className='wb-pill';
      b.innerHTML='<span></span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
      b.firstChild.textContent=v;b.setAttribute('aria-label','Filter entfernen: '+v);
      b.addEventListener('click',function(){var a=sel[g.k];a.splice(a.indexOf(v),1);sync();apply();});
      act.appendChild(b);
    });});
    if(any){var r=document.createElement('button');r.type='button';r.className='wb-linkbtn';r.textContent='Alle Filter zurücksetzen';r.addEventListener('click',reset);act.appendChild(r);}
    act.hidden=!any;
    try{var q=new URLSearchParams(location.search);groups.forEach(function(g){if(sel[g.k].length)q.set(g.k,sel[g.k].join(','));else q.delete(g.k);});if(sort.value!=='rec')q.set('sort',sort.value);else q.delete('sort');var s=q.toString();history.replaceState(null,'',location.pathname+(s?'?'+s:'')+location.hash);}catch(e){}
  }
  function sync(){groups.forEach(function(g){[].forEach.call(box.querySelectorAll('[data-g="'+g.k+'"] input'),function(i){i.checked=sel[g.k].indexOf(i.value)>-1;});});}
  function reset(){groups.forEach(function(g){sel[g.k]=[];});sync();apply();}
  [].forEach.call(root.querySelectorAll('[data-wb-reset]'),function(b){b.addEventListener('click',reset);});

  function doSort(){
    var m=sort.value,a=items.slice();
    if(m==='pa')a.sort(function(x,y){return +x.dataset.price-+y.dataset.price||+x.dataset.i-+y.dataset.i;});
    else if(m==='pd')a.sort(function(x,y){return +y.dataset.price-+x.dataset.price||+x.dataset.i-+y.dataset.i;});
    else if(m==='new')a.sort(function(x,y){return +y.dataset.pub-+x.dataset.pub||+x.dataset.i-+y.dataset.i;});
    else a.sort(function(x,y){return +x.dataset.i-+y.dataset.i;});
    a.forEach(function(el){grid.appendChild(el);});
  }
  try{var s0=new URLSearchParams(location.search).get('sort');if(s0&&sort.querySelector('option[value="'+s0+'"]'))sort.value=s0;}catch(e){}
  sort.addEventListener('change',function(){doSort();apply();});
  tool.hidden=false;
  doSort();apply();
})();

/* Unterkategorien: aktive Kategorie mobil in den sichtbaren Bereich schieben */
(function(){
  var l=document.querySelector('.wb-cnav__list'),a=l&&l.querySelector('[aria-current="page"]');
  if(a&&l.scrollWidth>l.clientWidth){var li=a.parentNode;l.scrollLeft=Math.max(0,li.offsetLeft-l.offsetLeft-16);}
})();

/* SEO-Text: lange Texte zunächst gekürzt, per Knopf aufklappbar (Inhalt bleibt im HTML) */
(function(){
  [].forEach.call(document.querySelectorAll('[data-wb-more]'),function(b){
    var t=b.querySelector('.wb-cseo__txt'),btn=b.querySelector('.wb-cseo__btn');if(!t||!btn)return;
    if(t.scrollHeight<=320)return;
    b.classList.add('is-clamped');btn.hidden=false;
    btn.addEventListener('click',function(){var o=b.classList.toggle('is-clamped');btn.setAttribute('aria-expanded',o?'false':'true');btn.textContent=o?'Weiterlesen':'Weniger anzeigen';});
  });
})();
